import { erpAxios } from '..';

const getCRK = async (uName) => {
  const { data } = await erpAxios.get(`/crkKrediti/${uName}`);
  return data;
};

export default getCRK;
